import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue-demi';
import {
  AbSection,
  AbContainer,
  AbSectionLayout,
  AbTitle,
  AbDescription,
  AbTabs,
  AbCatalogCards,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import { TextAlign } from '../../../../types';

interface CatalogProduct {
  productId?: string | null;
  customLink?: string | null;
  description?: string | null;
  priceText?: string | null;
  image?: {
    src?: string | null;
    alt?: string | null;
  };
  name?: string | null;
  sku?: string | null;
  price?: string | null;
  link?: string | null;
  disableClick?: boolean | null;
}

interface Tab {
  title: string;
  items: CatalogProduct[];
}

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  hideSku?: boolean | null;
  hidePrice?: boolean | null;
  tabs: Tab[];
  spacing?: Spacing | null;
  textAlign?: TextAlign | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogSectionProductsTabs',
  props: {
    id: null,
    title: null,
    description: null,
    hideSku: { type: [Boolean, null] },
    hidePrice: { type: [Boolean, null] },
    tabs: null,
    spacing: null,
    textAlign: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  hideSku?: boolean | null;
  hidePrice?: boolean | null;
  tabs: Tab[];
  spacing?: Spacing | null;
  textAlign?: TextAlign | null;
};

const DEFAULT_TEXT_ALIGN = 'center';
const INIT_ACTIVE_TAB_INDEX = 0;




const abTabs = computed(() => props.tabs.map((tab) => tab.title));

const activeTabIndex = ref(INIT_ACTIVE_TAB_INDEX);

const activeTab = computed(() => props.tabs[activeTabIndex.value]);

const onTabChange = (newActiveTabIndex: number) => {
  activeTabIndex.value = newActiveTabIndex;
  emit('change', newActiveTabIndex);
};

return { __sfc: true,DEFAULT_TEXT_ALIGN, INIT_ACTIVE_TAB_INDEX, emit, props, abTabs, activeTabIndex, activeTab, onTabChange, AbSection, AbContainer, AbSectionLayout, AbTitle, AbDescription, AbTabs, AbCatalogCards }
}

})